import { Check } from "lucide-react";
import { useLang } from "../../i18n/LangContext";

export const Progress = ({ step, maxStep, onJump }) => {
  const { t } = useLang();
  const steps = t("wizard.steps");
  return (
    <nav aria-label={t("wizard.stepOf", { n: step + 1 })} className="mb-8">
      <p className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-[#FACC15]" data-testid="wizard-step-indicator">{t("wizard.stepOf", { n: step + 1 })}</p>
      <ol className="grid grid-cols-3 gap-2">
        {steps.map((label, i) => {
          const done = i < step;
          const current = i === step;
          const reachable = i <= maxStep;
          return (
            <li key={label}>
              <button
                type="button"
                disabled={!reachable}
                onClick={() => onJump(i)}
                data-testid={`wizard-step-tab-${i + 1}`}
                aria-current={current ? "step" : undefined}
                className="group w-full text-left disabled:cursor-not-allowed"
              >
                <span className={`block h-1.5 rounded-full transition-colors ${current ? "bg-[#DC2626]" : done ? "bg-[#FACC15]" : "bg-[#2E2E3A]"}`} />
                <span className={`mt-2 flex items-center gap-1 text-[11px] sm:text-xs font-semibold uppercase ${current ? "text-white" : done ? "text-[#FACC15]" : "text-gray-500"}`}>
                  {done && <Check className="h-3 w-3 shrink-0" aria-hidden="true" />}
                  <span className="truncate">{label}</span>
                </span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
